import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-media-readers",
  templateUrl: "./media-readers.component.html",
  styleUrls: ["./media-readers.component.scss"],
  standalone: false,
})
export class MediaReadersComponent implements OnInit {
  @Input() path: string = "";
  @Input() type: string = "";
  @Input() controls: boolean = false;
  @Output() next: EventEmitter<any> = new EventEmitter<any>();
  @Output() prev: EventEmitter<any> = new EventEmitter<any>();
  @Output() close: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}

  ngOnInit() {}
  closeModal() {
    this.close.emit();
  }
  nextMedia() {
    this.next.emit();
  }
  prevMedia() {
    this.prev.emit();
  }
}
